import { object, ObjectSchema, string } from 'yup';

import { FormErrorMessage } from '~/constants/messages';
import { mobilePhoneRegexp } from '~/constants/regexp';

import { Fields } from './types';

export const validationSchema: ObjectSchema<Fields> = object({
  mobilePhone: string()
    .label('電話番号（携帯）')
    .matches(mobilePhoneRegexp, FormErrorMessage.invalid)
    .required(FormErrorMessage.required),
});
